import React from "react";
import FixedPageItem from "../../custom/FixedPageItem";
import { CircularProgress, Typography } from "@material-ui/core";

export function FixedFooterPageItem({ children, height = 70, loading, style = {} }) {
  return (
    <FixedPageItem elevation={1} height={height} style={{ borderRadius: "10px 10px 0px 0px", padding: 12, ...style }}>
      {loading ? (
        <div style={{ gridColumn: "span 2", textAlign: "center", paddingTop: 12 }}>
          <CircularProgress size={24} />
        </div>
      ) : (
        children
      )}
    </FixedPageItem>
  );
}

export function FooterItem({ title, subtitle, variant = "caption", align = "left", presubtitle = "" }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", textAlign: align }}>
      <Typography variant={variant} color="textPrimary">
        {title}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {presubtitle} {subtitle}
      </Typography>
    </div>
  );
}
